import { PlusIcon } from "@heroicons/react/16/solid";
import {
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarSpacer,
} from "../../../design/sidebar";
import { useMatter } from "../../../contexts/MatterContext";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "../../../design/dropdown";
import { Avatar } from "../../../design/avatar";

const SelectMatterDropdown = () => {
  const navigate = useNavigate();
  const { matters, currentMatterId, currentMatter } = useMatter();

  const onMatterSelected = (matterId: string) => {
    localStorage.setItem("currentMatterId", matterId);
    navigate(`/events`);
    window.location.reload();
  };

  if (!matters) return null;

  return (
    <Dropdown>
      <DropdownButton as={SidebarItem} className="mb-2.5">
        <Avatar src={require("../../../assets/logo_placeholder.png")} square />
        <SidebarLabel>
          {currentMatter?.me?.name ?? currentMatterId ?? "Choose Matter"}
        </SidebarLabel>
        <ChevronDownIcon />
      </DropdownButton>
      <DropdownMenu className="min-w-64" anchor="bottom start">
        {matters &&
          matters.length > 0 &&
          matters.map((matter) => (
            <DropdownItem
              key={matter._id}
              onClick={() => onMatterSelected(matter._id)}
            >
              {matter.me?.name ?? matter.identifier ?? matter._id}
            </DropdownItem>
          ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default SelectMatterDropdown;
